import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: ContactDataManagementFeatureConfig = {
    address: {
        countrySelect: false,
        maxCityLength: 35,
        maxStreetLength: 35,
        poBoxType: false,
        streetNumberField: false,
        additionalFields: false,
        countyField: false,
        streetTypeSelect: false,
        streetTypeField: false,
    },
    addressDeleteDelayAlert: false,
    changeNotEditableContactMessengerTopicId: undefined,
    mainContactSetting: false,
    phone: {
        summaryFormat: 'NATIONAL',
        typeValidation: true,
    },
    alwaysSetNewContactAsMain: false,
    legacy: {
        editAndViewHandover: false,
        useLegacyApiOnlyForViewContacts: false,
    },
    managePersonalContactsViaExternalApp: false,
    personalContactsExternalAppTargetClientId: '',
    proofOfAddressExternalApplication: false,
    personalDataUsageTooltip: false,
    showEmptyBusinessContacts: false,
    newBusinessContactEntryAllowed: false,
    operationAgnosticSigningEnabled: false,
    showEmptyPersonalContacts: true,
};
